import { Position } from '@capacitor/geolocation';
import { Action, createReducer, on } from '@ngrx/store';
import { AppGlobal } from './store.global';
import { appStoreGlobalActions } from './store.global.action';
import { appStoreGlobalIS } from './store.global.state';

const appStoreGlobalRegister = createReducer(
  appStoreGlobalIS,

  on(appStoreGlobalActions.setUserAction, (state, { user }) => ({
    ...state,
    user,
  })),

  on(appStoreGlobalActions.setCollaboratorAction, (state, { collaborator }) => ({
    ...state,
    collaborator,
    document: `${collaborator?.agentCode}`,
    role: collaborator?.roleCode,
    isSalesforce: collaborator?.roleCode === '1' || collaborator?.roleCode === '2',
  })),

  on(appStoreGlobalActions.setCompanyAction, (state, { company }) => ({
    ...state,
    company,
  })),

  on(appStoreGlobalActions.setIsLoadingAction, (state, { isLoading }) => ({
    ...state,
    isLoading,
  })),

  on(appStoreGlobalActions.setIsSavingAction, (state, { isSaving }) => ({
    ...state,
    isSaving,
  })),

  on(appStoreGlobalActions.setScreenIdAction, (state, { screenId }) => ({
    ...state,
    screenId,
  })),

  on(appStoreGlobalActions.setTitleAction, (state, { title }) => ({
    ...state,
    title,
  })),

  on(appStoreGlobalActions.setSubtitleAction, (state, { subtitle }) => ({
    ...state,
    subtitle,
  })),

  on(appStoreGlobalActions.setScreenSizeAction, (state, { isWeb, isSmall, isPortrait, isMedium, isLarge }) => ({
    ...state,
    isWeb,
    isSmall,
    isPortrait,
    isMedium,
    isLarge,
  })),

  on(appStoreGlobalActions.setInnerHeightAction, (state, { innerHeight }) => ({
    ...state,
    innerHeight,
  })),

  on(appStoreGlobalActions.setInnerWidthAction, (state, { innerWidth }) => ({
    ...state,
    innerWidth,
  })),

  on(appStoreGlobalActions.setConnectedAction, (state, { connected }) => ({
    ...state,
    connected,
  })),

  on(appStoreGlobalActions.setAppointmentsToSyncAction, (state, { appointmentsToSync }) => ({
    ...state,
    appointmentsToSync,
  })),

  on(appStoreGlobalActions.setOrdersToSyncAction, (state, { ordersToSync }) => ({
    ...state,
    ordersToSync,
  })),

  on(appStoreGlobalActions.setCustomersToSyncAction, (state, { customersToSync }) => ({
    ...state,
    customersToSync,
  })),

  on(appStoreGlobalActions.setNotificationCounterAction, (state, { notificationCounter }) => ({
    ...state,
    notificationCounter,
  })),

  on(appStoreGlobalActions.decreaseNotificationCounterAction, (state) => ({
    ...state,
    notificationCounter:
      !state.notificationCounter || state.notificationCounter === 0 ? 0 : state.notificationCounter - 1,
  })),

  on(appStoreGlobalActions.increaseNotificationCounterAction, (state) => ({
    ...state,
    notificationCounter: (state.notificationCounter ?? 0) + 1,
  })),

  on(appStoreGlobalActions.setNotificationCounterDtoAction, (state, { notificationCounterDto }) => ({
    ...state,
    notificationCounterDto,
  })),

  on(appStoreGlobalActions.setNotificationCounterDtoTotalAction, (state, { value }) => {
    let total = (state.notificationCounterDto?.total ?? 0) + value;
    if (total < 0) {
      total = 0;
    }
    return {
      ...state,
      notificationCounterDto: {
        ...state.notificationCounterDto,
        total,
      },
    };
  }),

  on(appStoreGlobalActions.setNotificationCounterDtoStarredAction, (state, { value }) => {
    let starred = (state.notificationCounterDto?.starred ?? 0) + value;
    if (starred < 0) {
      starred = 0;
    }
    return {
      ...state,
      notificationCounterDto: {
        ...state.notificationCounterDto,
        starred,
      },
    };
  }),

  on(appStoreGlobalActions.setNotificationCounterDtoImportantAction, (state, { value }) => {
    let important = (state.notificationCounterDto?.important ?? 0) + value;
    if (important < 0) {
      important = 0;
    }
    return {
      ...state,
      notificationCounterDto: {
        ...state.notificationCounterDto,
        important,
      },
    };
  }),

  on(appStoreGlobalActions.setNotificationCounterDtoDeletedAction, (state, { value }) => {
    let deleted = (state.notificationCounterDto?.deleted ?? 0) + value;
    if (deleted < 0) {
      deleted = 0;
    }
    return {
      ...state,
      notificationCounterDto: {
        ...state.notificationCounterDto,
        deleted,
      },
    };
  }),

  on(appStoreGlobalActions.setActiveCampaignsAction, (state, { activeCampaigns, resourceIds, campaignIds }) => ({
    ...state,
    activeCampaigns,
    campaignIds,
    resourceIds,
    totalCampaigns: campaignIds.length,
    campaignsLoaded: 0,
  })),

  on(appStoreGlobalActions.setCampaignAction, (state, { id, campaign }) => ({
    ...state,
    campaigns: {
      ...state.campaigns,
      [id]: campaign,
    },
    campaignsLoaded: state.campaignsLoaded + 1,
  })),

  on(appStoreGlobalActions.setCampaignResourcesAction, (state, { id, resources }) => ({
    ...state,
    campaignResources: {
      ...state.campaignResources,
      [id]: resources,
    },
  })),

  on(appStoreGlobalActions.setCampaignsLoadingAction, (state, { value: campaignsLoading }) => ({
    ...state,
    campaignsLoading,
  })),

  on(appStoreGlobalActions.setAiChatHistoryAction, (state, { aiChatHistory }) => ({
    ...state,
    aiChatHistory,
  })),

  on(appStoreGlobalActions.addAiChatHistoryAction, (state, message) => ({
    ...state,
    aiChatHistory: [...(state.aiChatHistory ?? []), message],
  })),

  on(appStoreGlobalActions.delAiChatHistoryAction, (state, { errorId }) => ({
    ...state,
    aiChatHistory: state.aiChatHistory.filter((item) => item.errorTimestamp !== errorId),
  })),

  on(appStoreGlobalActions.setDynamicFormsAssignedAction, (state, { myFormsAssigned }) => ({
    ...state,
    myFormsAssigned,
  })),

  on(appStoreGlobalActions.setDynamicFormsAction, (state, { myForms, isRefresh }) => ({
    ...state,
    myForms,
    totalForms: isRefresh ? -1 : myForms.length,
  })),

  on(appStoreGlobalActions.enableDisableWatchUserPosition, (state, { isWatchingPosition }) => ({
    ...state,
    isWatchingPosition,
  })),
  on(appStoreGlobalActions.setUserPosition, (state, { position }) => ({
    ...state,
    position:
      position ??
      ({
        coords: { latitude: 0, longitude: 0 },
      } as Position),
  })),
);

export const appStoreGlobalReducer = (state: AppGlobal, action: Action): any => appStoreGlobalRegister(state, action);
